
import jsPDFValorizedTemplate, { OutputType } from "./ValorizedTemplate";
import currency from 'currency.js'


// Date Fns is used to format the dates we receive
// from our API call
import { parseISO, format } from 'date-fns';
import logo from '../../../assets/img/logo.jpg'; // Tell webpack this JS file uses this image


// define a generatePDF function that accepts a inventorys argument
const generateValorizedPrintPDF = (inventory, configData, parameters) => {
    
    // console.log("Inven:",inventory)
    const myDate = format(new Date(), 'dd/MM/yyyy')
    const dateFrom = format(new Date(parameters.date_from), 'dd/MM/yyyy')
    const dateTo = format(new Date(parameters.date_to), 'dd/MM/yyyy')
    const dataFrom = parameters.data_from === "" ? "0" : parameters.data_from
    const dataTo = parameters.data_to === "" ? "999999999" : parameters.data_to    
    const currFormat = { decimal: ',', symbol: '', separator: '.' }

    var totalCost = 0;
    var totalPrice = 0;
    inventory.forEach(function (record) {
        totalCost += record.stock*record.cost;
        totalPrice += record.stock*record.price;
    });    
    
    totalCost = currency(totalCost, currFormat).format()
    totalPrice = currency(totalPrice, currFormat).format()

    var arrLines = Array.from(inventory, (item, index) => ([
        index + 1,
        item.code,
        item.name,      
        item.format,
        item.stock,
        currency(item.cost, currFormat).format(),
        currency(item.price, currFormat).format()

    ]))

    arrLines = [...arrLines,
        [{content:"", colSpan: 4, styles: { fillColor: [220,220,220], textColor: [0,0,0]}},
        {
            content: `Totales:`,  styles: { fillColor: [220,220,220], textColor: [0,0,0]}
        },
        {
            content: totalCost, styles: { fillColor: [220,220,220], textColor: [0,0,0]}
        },
        {
            content: totalPrice, styles: { fillColor: [220,220,220], textColor: [0,0,0] }
        }    
        ]]


    var props = {
        outputType: 'blob',
        returnJsPDFDocObject: true,
        fileName: `Inventory-report-valorized-${new Date()}`,
        orientationLandscape: false,
        logo: {
            src: logo,
            width: 30.33, //aspect ratio = width/height
            height: 26.66,
            margin: {
                top: 0, //negative or positive num, from the current position
                left: 0 //negative or positive num, from the current position
            }
        },        
        business: {
            name: configData.company_name,
            address: `${configData.company_address1} - ${configData.company_address2}`,
            phone: configData.company_phone,
            email: configData.company_email,
            email_1: configData.company_email1,
            website: configData.company_web_url,
            date: myDate
        },
        invoice: {
            label: `Reporte Valorizado de Inventario`,            
            label2: `Desde: ${dateFrom} - Hasta: ${dateTo}`,                          
            label3: `Producto Desde: ${dataFrom} - Producto Hasta: ${dataTo}`,      
            headerBorder: true,
            tableBodyBorder: true,
            header: ["#", "Codigo", "Producto", "Formato", "Existencia", "Costo", "Precio"],
            table: arrLines,
            invTotalLabel: "Total Valor Inventario:",
            invTotal: 0,
            InvTotalCost: totalCost,
            InvTotalPrice: totalPrice,
            invCurrency: "$",
            row1: {
                
            },
            row2: {
                
            },
            row3: {
                
            },
            invDescLabel: "Descripcion:",
            invDesc: inventory.description,
        },
        footer: {
            text: "",
        },
        pageEnable: true,
        pageLabel: "Page ",
    };
    const pdfCreated = jsPDFValorizedTemplate(props); //returns number of pages created
    var blob = pdfCreated.blob;

    var pdfObject = pdfCreated.jsPDFDocObject;


    window.open(URL.createObjectURL(pdfObject.output("blob")))

    // pdfCreated.jsPDFDocObject.output("blob"); //or .output('<outputTypeHere>');

};

export default generateValorizedPrintPDF;